module.exports = __webpack_public_path__ + "static/logo-light-5f0c4e8953165556aaf73b0bd6ead374.svg";